import { toast } from "react-toastify";
import { call, put, takeEvery } from "redux-saga/effects";
import { GET_CUSTOMER_COMPLAINTS_REQUESTED, GET_CUSTOMER_COMPLAINTS_SUCCESS, GET_CUSTOMER_COMPLAINTS_FAILED,  UPDATE_COMPLAINT_REQUESTED, 
  UPDATE_COMPLAINT_SUCCESS, 
  UPDATE_COMPLAINT_FAILED  } from "resources/actionTypes";
import { customerComplaintApi, updateComplainApi } from "services/CustomerComplaintsService";

function* fetchCustomerComplaints(action) {
  try {
    const payload = action.payload || {};
    const customerComplaints = yield call(customerComplaintApi, payload);
    yield put({ type: GET_CUSTOMER_COMPLAINTS_SUCCESS, customerComplaints: customerComplaints });
    console.log("Customer Complaints Data", customerComplaints);
  } catch (e) {
    yield put({ type: GET_CUSTOMER_COMPLAINTS_FAILED, message: e.message });
    toast.error(e.message || "Fetching Customer Complaints Failed");
  }
}

// Update Complaint
function* updateComplaint(action) {
  try {
    const { id, status, comment } = action.payload;
    const payload = { status, comment };
    const response = yield call(updateComplainApi, id, payload);
    toast.success(response?.message || "Complaint Updated Successfully");
    console.log("Update Complaint response", response);
    yield put({ type: UPDATE_COMPLAINT_SUCCESS, response });
    console.log("Complaint Update Response", response);
  } catch (e) {
    yield put({ type: UPDATE_COMPLAINT_FAILED, message: e.message });
    toast.error(e.message || "Updating Complaint Failed");
  }
}

export function* customerComplaintsSaga() {
  yield takeEvery(GET_CUSTOMER_COMPLAINTS_REQUESTED, fetchCustomerComplaints);
  yield takeEvery(UPDATE_COMPLAINT_REQUESTED, updateComplaint);
}